import { AppendTenantNoteResponse, NoteInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Notes/Notes.Controller.ts
export class NotesAPI {
  static async getNotesForUser(orgId: number, userId: number, includeArchived: boolean): Promise<NoteInterface[]> {
    return APIService.Server.get<NoteInterface[]>(`/notes/org/${orgId}/user/${userId}`, { includeArchived });
  }
  static async updateNote(noteId: number, note: Partial<NoteInterface>): Promise<NoteInterface> {
    return APIService.Server.put<NoteInterface>(`/notes/note/${noteId}`, { note });
  }
  static async createOrUpdateNote(
    orgId: number,
    userId: number,
    updateExistingNote: boolean,
    note: Omit<NoteInterface, "createdAt" | "updatedAt" | "id">
  ): Promise<NoteInterface> {
    return APIService.Server.post<NoteInterface>(`/notes/org/${orgId}/user/${userId}/note`, { note, updateExistingNote });
  }

  static async postNoteToFMS(orgId: number, userId: number, note: Partial<NoteInterface>): Promise<AppendTenantNoteResponse> {
    return APIService.Server.post<AppendTenantNoteResponse>(`/notes/org/${orgId}/user/${userId}/post-note-to-fms`, { note });
  }

  //   static async create(orgId: number, notification: Partial<NotificationBaseInterface>): Promise<NotificationBaseInterface> {
  //     // return APIService.Server.post<NotificationBaseInterface>(`/notifications/org/${orgId}/notification`, { notification });
  //   }
}
